export interface KeyDef {
  description?: string;
}

export interface CollectionDef {
  description?: string;
  keys: Record<string, KeyDef>;
}

export type LocalDBSchema = Record<string, CollectionDef>;

// Statically defined collections and keys
export const localDBSchema: LocalDBSchema = {
  ui: {
    description: 'UI preferences (theme, zoom, layout, KDS settings, etc.)',
    keys: {
      colorMode: { description: 'Color mode preference: light | dark | system' },
      baseFontSizePx: { description: 'Root font-size in px for rem scaling' },
      appZoom: { description: 'Global UI zoom factor (e.g., 1.0 = 100%)' },
      sidebarExpanded: { description: 'Desktop sidebar expanded state (default: true)' },
    },
  },
  notes: {
    description: 'User personal notes and scratchpad',
    keys: {},
  },
  kds: {
    description: 'Kitchen Display System preferences and state',
    keys: {
      zoom: { description: 'KDS zoom scale factor (0.5–2.0)' },
    },
  },
  restaurant: {
    description: 'Restaurant view filters and options',
    keys: {
      salonZoom: { description: 'Zoom factor for salon map' },
      pinnedSalon: { description: 'Pinned (fixed) salon selection' },
      viewPresentation: { description: 'Preferred presentation: mapa | lista' },
      displayPrefs: { description: 'User display preferences for mesas (number/tag/time/charges/waiter)' },
      hosterMode: { description: 'Whether master mode (POS-style side panel) is enabled' },
    },
  },
  pedidosConfig: {
    description: 'Order taker configuration and preferences',
    keys: {
      sortItemsAlphabetically: { description: 'Sort items within categories alphabetically (default: false)' },
      sortCategoriesAlphabetically: { description: 'Sort category buttons alphabetically (default: false)' },
      alwaysShowSelectorModal: { description: 'Always show selector modal even for items with only optional selections (default: false)' },
      enableDoubleClickCourse: { description: 'Enable double-click to tag items as ENTRADA/FONDO in cart (default: false)' },
      autoPrintCancellationComandas: { description: 'Automatically notify kitchen for cancellation/elimination comandas (default: false)' },
      enableQuickBoletaPrint: { description: 'Show one-click SII Boleta (tipo 39) print button on paid receipts (default: false)' },
    },
  },
  cache: {
    description: 'Global cache settings',
    keys: {
      enabled: { description: 'Whether API response caching is enabled' },
    },
  },
  alerts: {
    description: 'User alert preferences and timestamps',
    keys: {
      sessionTime: { description: 'Timestamp when user last acknowledged session timeout alert' },
    },
  },
  auth: {
    description: 'Authentication state and validation cache',
    keys: {
      isLogged: { description: 'Whether user is currently authenticated' },
      lastCheck: { description: 'Timestamp of last authentication validation' },
      lastValidation: { description: 'Result of last user state validation' },
      loggedOut: { description: 'Explicit logout flag to force re-authentication' },
    },
  },
  notifications: {
    description: 'Notification preferences and sound settings',
    keys: {
      enabled: { description: 'Master switch for all notifications (default: true)' },
      soundVolume: { description: 'Global notification sound volume 0-100 (default: 50)' },
      topicSettings: { description: 'Per-topic notification and sound settings' },
    },
  },
};

export default localDBSchema;
